import androidRuItem1 from 'images/app/android/android-ru-1.png';
import androidRuItem2 from 'images/app/android/android-ru-2.png';
import androidRuItem3 from 'images/app/android/android-ru-3.png';
import androidRuItem4 from 'images/app/android/android-ru-4.png';
import androidEnItem1 from 'images/app/android/android-en-1.png';
import androidEnItem2 from 'images/app/android/android-en-2.png';
import androidEnItem3 from 'images/app/android/android-en-3.png';
import androidEnItem4 from 'images/app/android/android-en-4.png';
import iosRuItem1 from 'images/app/ios/ios-ru-1.png';
import iosRuItem2 from 'images/app/ios/ios-ru-2.png';
import iosRuItem3 from 'images/app/ios/ios-ru-3.jpg';
import iosEnItem1 from 'images/app/ios/ios-en-1.png';
import iosEnItem2 from 'images/app/ios/ios-en-2.png';
import iosEnItem3 from 'images/app/ios/ios-en-3.jpg';
import apkImage1 from 'images/app/apk/apk-1.png';
import apkImage2 from 'images/app/apk/apk-2.png';
import apkImage3 from 'images/app/apk/apk-3.png';
import apkImage4 from 'images/app/apk/apk-4.png';
import apkImage5 from 'images/app/apk/apk-5.png';
import apkImage6 from 'images/app/apk/apk-6.png';
import tekegramEnItem1 from 'images/app/telegram/telegram-en-1.jpg';
import tekegramEnItem2 from 'images/app/telegram/telegram-en-2.jpg';
import tekegramEnItem3 from 'images/app/telegram/telegram-en-3.jpg';
import tekegramRuItem1 from 'images/app/telegram/telegram-ru-1.jpg';
import tekegramRuItem2 from 'images/app/telegram/telegram-ru-2.jpg';
import tekegramRuItem3 from 'images/app/telegram/telegram-ru-3.jpg';
import appManual1Png from 'images/app/manual/manual1.png';
import appManual2Png from 'images/app/manual/manual2.png';
import appManual3Png from 'images/app/manual/manual3.png';
import appManual4Png from 'images/app/manual/manual4.png';
import appManual5Png from 'images/app/manual/manual5.png';
import appManual6Png from 'images/app/manual/manual6.png';

export const PLATFORM_IMAGES = {
    android: {
        en: [
            androidEnItem1,
            androidEnItem2,
            androidEnItem3,
            androidEnItem4
        ],
        ru: [
            androidRuItem1,
            androidRuItem2,
            androidRuItem3,
            androidRuItem4
        ]
    },
    ios: {
        en: [
            iosEnItem1,
            iosEnItem2,
            iosEnItem3
        ],
        ru: [
            iosRuItem1,
            iosRuItem2,
            iosRuItem3
        ]
    }
};

export const APK_IMAGES = [
    apkImage1,
    apkImage2,
    apkImage3,
    apkImage4,
    apkImage5,
    apkImage6
];

export const TELEGRAM_IMAGES = {
    en: [
        tekegramEnItem1,
        tekegramEnItem2,
        tekegramEnItem3
    ],
    ru: [
        tekegramRuItem1,
        tekegramRuItem2,
        tekegramRuItem3
    ]
};

export const APP_MANUAL_IMAGES = {
    appManual1Png,
    appManual2Png,
    appManual3Png,
    appManual4Png,
    appManual5Png,
    appManual6Png
};
